import { DateInput, DateInputProps } from "@mantine/dates";
import { highlightToday } from "app/utils/util-functions";

export default function BlackDateInput({ ...props }: DateInputProps) {
    return (
        <DateInput
            firstDayOfWeek={0}
            popoverProps={{ withinPortal: true }}
            valueFormat="DD-MMM-YYYY"
            classNames={{
                label: "black-input-label",
                input: "black-text-input-input",
                root: "black-text-input-root",
            }}
            getDayProps={highlightToday()}
            {...props}
        />
    )
}